window.VegasOrder = {};

$(document).on('change', '.delivery-variant input[type=radio]', function () {
	var $container = $(this).closest('.delivery-variant');
	var type = $container.data('type');

	$('.delivery-variant').each(function () {
		$(this).removeClass('active');
		$(this).find('.make-required').removeAttr('required');
	});

	$container.addClass('active');
	$container.find('.make-required').attr('required', 'required');

	var city_id = $("#order_city_id").val();

	// payments
	var delivery = deliveryMap[city_id].deliveries;
	if (typeof delivery[type].payments !== 'undefined') {
		$('.payment-variant [name=type_payment]').attr('disabled', 'disabled');
		for (var i in delivery[type].payments) {
			$('.payment-variant [name=type_payment][value="' + delivery[type].payments[i] + '"]').removeAttr('disabled');
		}
		$('.payment-variant [name=type_payment]:not([disabled])').eq(0).prop('checked', 'checked');
	} else {
		$('.payment-variant [name=type_payment]').removeAttr('disabled');
	}

	var params = $("#form-order").serializeArray();
	$.get('/cart/order/data', params, function (data) {
		if (typeof data.sums.sum_delivery !== 'undefined') {
			var $d = $('.vg-shop-order__total [data-sum="delivery"]');
			if (isNaN(data.sums.sum_delivery)) {
				$d.find('span').html(data.sums.sum_delivery);
			} else {
				$d.find('span').html(
					Number(data.sums.sum_delivery) > 0 ? output_money(data.sums.sum_delivery) : 'бесплатно'
				);
			}
		}

		if (typeof data.sums.sum_pickup_discount !== 'undefined') {
			var $pickupDiscount = $('.vg-shop-order__total [data-sum="pickup_discount"]');
			if (Number(data.sums.sum_pickup_discount) > 0) {
				$pickupDiscount.find('span').html(output_money(data.sums.sum_pickup_discount));
				$pickupDiscount.show();
			} else {
				$pickupDiscount.hide();
			}
		}

		if (typeof data.sums.sum !== 'undefined') {
			var $d = $('.vg-shop-order__total [data-sum="sum"]');
			$d.find('span').html(output_money(data.sums.sum));
		}

		if (typeof data.products !== 'undefined') {
			for (var i in data.products) {
				var product = data.products[i],
					$p = $('[data-cart="product"][data-pivot_id="' + product.pivot_id + '"]');

				$p.find('[data-product-price]').html(product.price_formatted);

				if (Number(product.pickup_discount) > 0) {
					$p.find('[data-product-price-original]').show();
					$p.find('[data-product-pickup-discount]')
						.html('Скидка за самовывоз: ' + output_money(product.pickup_discount_total))
						.show();
				} else {
					$p.find('[data-product-price-original]').hide();
					$p.find('[data-product-pickup-discount]').hide();
				}
			}
		}
	});

	let $cdekDeliveryPickup = $("#delivery_cdek_pickup");
	$cdekDeliveryPickup.select2({
		theme: "bootstrap",
		language: "ru",
		ajax: {
			url: $cdekDeliveryPickup.data('route'),
			data: function (params) {
				return {
					search: params.term,
					city_id: city_id
				}
			}
		}
	})

	return false;
});
